export default "__VITE_ASSET__C90dGsg1__"